import { EducatorPageChrome } from "@/pages/educators/page-chrome"

import { CardContent } from "@/components/ui/card"
import { PageBody } from "@/components/ui/layout"

import { DataDrivenSpecialityForm } from "./data-driven-form"
import { useDataDrivenEditProps } from "./page-props"

export default function EditDataDriven() {
  const { speciality } = useDataDrivenEditProps()

  return (
    <>
      <EducatorPageChrome />
      <PageBody>
        <CardContent>
          <DataDrivenSpecialityForm form={speciality} />
        </CardContent>
      </PageBody>
    </>
  )
}
